<template>
    <div>
        <van-nav-bar title="诗颂" left-arrow @click-left="$router.go(-1)" fixed />

        <div class="word">
            <div class="title">{{ poem.track_sn }}.{{ poem.title }}</div>
            <div class="paragraph">（{{ currentParagraph }}/{{ allWords.length }}）</div>
            <span :style="{ fontSize: fontSize + 'px' }" v-for="item in currentWords" :key="item.id">{{
                item.words
            }}</span>
        </div>

        <div class="btn">
            <van-button color="#b2ddfc50" @click="changeCurrentParagraph(-1)">
                <van-icon class-prefix="icon" name="zuojiantou" />
            </van-button>
            <van-button plain @click="changeFontSize(-2)">
                <van-icon class-prefix="icon" name="suoxiao" />
            </van-button>
            <van-button plain @click="changeFontSize(2)">
                <van-icon class-prefix="icon" name="fangda" />
            </van-button>
            <van-button color="#b2ddfc50" @click="changeCurrentParagraph(1)">
                <van-icon class-prefix="icon" name="youjiantou" />
            </van-button>
        </div>
    </div>
</template>

<script>
import { getPoemDetail } from '@/api/bible'

export default {
    data() {
        return {
            poem: {},
            allWords: [],
            currentParagraph: 1,
            currentWords: [],
            fontSize: 18,
        }
    },
    created() {
        getPoemDetail(this.$route.query.id).then((res) => {
            this.poem = res.data
            this.allWords = res.data.words
            this.currentWords = this.allWords[this.currentParagraph - 1]
        })
    },
    methods: {
        changeCurrentParagraph(num) {
            if ((this.currentParagraph === 1 && num < 0) || (this.currentParagraph === this.allWords.length && num > 0))
                return
            this.currentParagraph = this.currentParagraph + num
            this.currentWords = this.allWords[this.currentParagraph - 1]
        },
        changeFontSize(num) {
            if (this.fontSize + num >= 16 && this.fontSize + num <= 28) {
                this.fontSize += num
            }
        },
    },
}
</script>

<style lang="less" scoped>
.word {
    margin-top: 46px;
    text-align: center;
    background: white;
    padding: 20px 0;

    .title {
        font-size: 24px;
    }

    .paragraph {
        margin: 5px 0 15px 0;
    }

    span {
        display: inline-block;
        padding: 5px 0;
    }
}

.btn {
    padding: 20px;
    display: flex;
    justify-content: space-between;

    .van-button__text {
        color: @blue;
    }

    .icon {
        font-size: 26px;
    }
}
</style>
